import React from "react";
import cx from "classnames";
import { ReactComponent as ChevronRight } from "../../../../../images/svg/icons/chevron-right.svg";
import { IconTextLink } from "../../../../Atoms/IconTextLink/IconTextLink";

interface Props {
  label: string;
  linkUrl: string;
}

const QuickActionButton = ({ label, linkUrl }: Props) => {
  return (
    <IconTextLink
      variant="button-icon-text"
      renderLabel={
        <div className="flex">
          {label} <ChevronRight height={25} />
        </div>
      }
      linkUrl={linkUrl}
      className={cx(
        "hidden h-10 w-[154px] flex-shrink-0 border-none md:flex",
        "font-secondary text-color-neutral-one font-medium uppercase",
        "hover:bg-color-brand-two hover:text-white"
      )}
    />
  );
};

export default QuickActionButton;
